







































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Getter, Action } from 'vuex-class'
import ThePrivacyStatement from '@/components/ThePrivacyStatement.vue'
import TheTermsAndConditions from '@/components/TheTermsAndConditions.vue'
import { themeColors } from '@/plugins/vuetify/theme'
import { gradientBackgroundFromColor } from '@/utilities/colors'


const TOS_VERSION = '1.0'


@Component({
  components: { TheTermsAndConditions, ThePrivacyStatement }
})
export default class TermsAndConditionsPage extends Vue {

  termsAccepted = false
  termsDialog = false
  privacyDialog = false
  clicked = false

  @Getter('windowHeight', { namespace: 'system' }) windowHeight!: boolean
  @Getter('isPremiumUser', { namespace: 'auth' }) isPremiumUser!: boolean
  @Action('acceptAllTerms', { namespace: 'profiles' }) acceptAllTerms!: (version: string) => void
  @Action('save', { namespace: 'profiles' }) save!: () => Promise<boolean>

  messageForFreeUsers = `
    Met dit gratis account heb je toegang tot een klein gedeelte van de content.
  `
  //       Neem contact op met je werkgever of met PlanHR indien je een volledig account wenst.
  
  messageForAllUsers = `
    Vul de volgende vragen in zodat wij jouw trainingservaring kunnen optimaliseren!
  `

  get gradientBackground() { return gradientBackgroundFromColor(themeColors.menuBackground) }

  async next() {
    this.clicked = true
    if (this.termsAccepted) {
      await this.acceptAllTerms(TOS_VERSION)
      await this.save()
      this.$router.push('/')
    }
  }
}
